/* eslint-disable prettier/prettier */
import React from "react";

/**
 * Silent Callback for Token Refresh
 *
 * This page is loaded in a hidden iframe for silent token renewal.
 * It must be minimal and complete the OIDC callback process quickly.
 */
const SilentCallback = () => {
  return <div>Silent authentication in progress...</div>;
};

export default SilentCallback;
